import React, { Component } from "react";
import {
	Tooltip,
	OverlayTrigger,
	ListGroup,
	ListGroupItem,
	Row,
	Col,
} from "react-bootstrap";
import PropTypes from "prop-types";
import TableUtils from "../../../../../../../utils/TableUtils";
import lstrings from "../../../../../../../utils/LStrings";

export default class ObsDetails extends Component {
	render() {
		return (
			<div>
				<h4 className="text-center">{lstrings.verazObsTitle}</h4>
				<p className="text-center">{lstrings.verazObsDescription}</p>
				<Row>
					<Col sm={10} smPush={1} className='text_center'>
						<span>
							<strong>{lstrings.verazObsCantidadTitle}: </strong>
							{this.props.cantObs}
						</span>
						<br />
						<span>
							<strong>{lstrings.total}: </strong>
							{TableUtils.ARSFormat(
								this.props.montoObs,
								false,
								true
							)}
						</span>
					</Col>
				</Row>
				<Row>
					<Col sm={12}>
						<ListGroup>
							{this.props.detalleObs.map((elem, idx) => (
								<ListGroupItem key={idx}>
									<span>
										<strong>
											{lstrings.verazObsInformanteTitle}: {elem.nombreEntidad}
										</strong>
									</span>
									<br />
									<span>
										({TableUtils.dateFormat(elem.fecha)}){" "}
										{TableUtils.ARSFormat(
											elem.monto,
											false,
											true
										)}
									</span>
								</ListGroupItem>
							))}
						</ListGroup>
					</Col>
				</Row>
			</div>
		);
	}
}

ObsDetails.propTypes = {
	detalleObs: PropTypes.array,
	cantObs: PropTypes.number,
	montoObs: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/scenes/personas/components/personas-detalle/components/panel-veraz/components/ObsDetails.js